import { render } from "./NotFound.vue?vue&type=template&id=08a15c89"
const script = {}
script.render = render

export default script